import { request } from '../http';

export type PaymentProviderConfig = {
  id: string;
  provider: string;
  displayName: string;
  mode: string;
  isEnabled: boolean;
  publicConfig: Record<string, string>;
  secretConfig: Record<string, string | null>;
  status: string;
  lastTestedAt?: string | null;
  lastTestStatus?: string | null;
  lastTestError?: string | null;
};

export type PaymentProviderTestResult = {
  provider: string;
  ok: boolean;
  status: string;
  message?: string | null;
};

export const paymentProvidersService = {
  list(): Promise<{ items: PaymentProviderConfig[] }> {
    return request<{ items: PaymentProviderConfig[] }>('/payment-providers');
  },

  upsert(
    provider: string,
    body: {
      displayName?: string;
      mode?: string;
      isEnabled?: boolean;
      publicConfig?: Record<string, string>;
      secretConfig?: Record<string, string>;
      status?: string;
    }
  ): Promise<PaymentProviderConfig> {
    return request<PaymentProviderConfig>(`/payment-providers/${encodeURIComponent(provider)}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  },

  test(provider: string): Promise<PaymentProviderTestResult> {
    return request<PaymentProviderTestResult>(
      `/payment-providers/${encodeURIComponent(provider)}/test`,
      { method: 'POST' }
    );
  },
};
